import type { ITheme } from '@fluentui/react';

export const getStyles = (_: unknown, { palette = {} as ITheme['palette'] }: { palette?: ITheme['palette'] }) => ({
  campaignGoalItemContainer: {
    width: 176,
    height: 160,
    background: palette.white,
    position: 'relative',
    paddingLeft: 15,
    paddingRight: 15,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '2px',
    boxShadow: '0px 0.6px 1.8px rgba(0, 0, 0, 0.1), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)',
    '@media screen and (-ms-high-contrast: active)': {
      '&:focus': {
        border: `1px solid ${palette.white}`,
      },
      outline: '1px solid windowText !important',
      '&.is-selected': {
        outlineColor: 'highlight !important',
      },
    },
    '& .non-hover-check-icon': {
      display: 'inline-block',
    },
    '& .hovered-check-icon': {
      display: 'none',
    },
    '&:hover': {
      boxShadow: '0px 1.2px 3.6px rgba(0, 0, 0, 0.1), 0px 6.4px 14.4px rgba(0, 0, 0, 0.13)',
      cursor: 'pointer',
    },
    '&:focus': {
      outline: `2px solid ${palette.neutralSecondary}`,
    },
    '&:focus:hover': {
      outline: `3px solid ${palette.neutralSecondary}`,

    },
    '&:hover, &:focus': {
      '& .non-hover-check-icon': {
        display: 'none',
      },
      '& .hovered-check-icon': {
        display: 'inline-block',
      },
    },
    '&.is-selected': {
      outline: `1px solid ${palette.themePrimary}`,
      backgroundColor: palette.themeLighterAlt,
      '&:hover': {
        backgroundColor: palette.themeLighter,
        outline: `1px solid ${palette.themeDark}`,
      },
      '&:focus': {
        outline: `3px solid ${palette.themeDark}`,
      },
    },
  },

  campaignGoalItemContainerWithIcon: {
    paddingTop: 44,
  },

  campaignGoalItemContainerWithoutIcon: {
    paddingTop: 10,
  },

  goalTitle: {
    fontSize: 14,
    color: palette.black,
    fontWeight: 'bold',
    textAlign: 'center',
  },

  goalDescription: {
    fontSize: 14,
    color: palette.neutralPrimary,
  },

  image: {
    minHeight: '32px',
  },

  iconImage: {
    marginBottom: '16px',
  },

  nonIconImage: {
    width: 120,
    height: 108,
    marginBottom: -20,
  },

  checkIcon: {
    width: '20px',
    height: '20px',
    alignSelf: 'auto',
    position: 'absolute',
    top: 10,
    right: 10,
  },

  checkIconHightLight: {
    color: palette.blue,
  },

  checkIconNonHightLight: {
    color: palette.neutralTertiaryAlt,
  },

  checkIconUncheckHover: {
    color: palette.neutralSecondary,
  },
});
